export const MAINCASE_MAILER_SERVICE = 'https://mailer.maincase.io'
// export const MAINCASE_MAILER_SERVICE = 'http://localhost:8080'

export const MAINCASE_LINKEDIN = 'https://www.linkedin.com/company/maincase'
export const MAINCASE_INSTAGRAM = '#'
export const MAINCASE_TWITTER = '#'
